import React from 'react';

import Col from 'react-bootstrap/Col';
import CurrencyInput from '../shared/inputs/CurrencyInput';
import CustomTd from '../shared/table/CustomTd';
import SaveCancelButton from '../shared/buttons/SaveCancelButton';
import Form from 'react-bootstrap/Form';
import FormControl from '../shared/inputs/FormControl';
import SelectList from '../shared/inputs/SelectList';
import useForm from '../../utilities/useForm';

const PaymentEditor = ({
    cancelEdit,
    fetchData,
    item: initialItem
}) => {
    const getUrl = `/api/payments/edit/${initialItem.id}`;
    const postUrl = `/api/payments/edit`;

    const { item, reset, ...form } = useForm(getUrl, postUrl, { item: initialItem });

    const submitForm = () => {
        form.submitData(() => {
            fetchData();
            window.dispatchEvent(new Event('updateChangeLog'));
        }, paymentValidator);
    }

    return (
        <tr>
            <CustomTd>
                <Form.Row>
                    <Col md='7'>
                        <Form.Row>
                            <Col sm='6' className="mb-1 mb-md-0" style={{ height: '1.9em' }}>
                                <FormControl
                                    defaultValue={item.date}
                                    name="date"
                                    onChange={form.formChange}
                                    required={!item.newItem}
                                    type="date"
                                    validationError={item.date_error}
                                />
                            </Col>
                            <Col className="mb-1 mb-md-0" style={{ height: '1.9em' }}>
                                <SelectList
                                    placeholder="Payment Type"
                                    name="paymentType"
                                    onChange={form.formChange}
                                    value={item.paymentType}
                                    required={!item.newItem}
                                    validationError={item.paymentType_error}
                                >
                                    <option disabled value="">Payment Type</option>
                                    <option value="1">Credit Card</option>
                                    <option value="2">Check</option>
                                    <option value="3">Cash</option>
                                    <option value="4">Finance Program</option>
                                    <option value="6">Store Credit</option>
                                    <option value="10">Other</option>
                                </SelectList>
                            </Col>
                        </Form.Row>
                    </Col>
                    <Col md='5'>
                        <Form.Row>
                            <Col style={{ height: '1.9em' }}>
                                <CurrencyInput
                                    name="amount"
                                    onChange={form.formChange}
                                    placeholder="Amount"
                                    required={!item.newItem}
                                    validationError={item.amount_error}
                                    value={item.amount}
                                />
                            </Col>
                            <Col xs="6" md="auto" style={{ height: '1.9em' }}>
                                <div className="d-flex" style={{ paddingTop: '2px' }}>
                                    <label className="custom-control custom-checkbox d-inline-flex mb-0">
                                        <input type="checkbox"
                                            checked={item.isDeposit || false}
                                            className="custom-control-input"
                                            name="isDeposit"
                                            onChange={form.formChange}
                                        />
                                        <span className="custom-control-label">&nbsp;</span>
                                    </label>
                                    <label className="mb-0" style={{ marginLeft: '-5px' }}>Deposit</label>
                                </div>
                            </Col>
                        </Form.Row>
                    </Col>
                </Form.Row>
            </CustomTd>
            <CustomTd className='button-cell' width={90}>
                <div style={{ height: '1.9em', paddingTop: '2px' }}>
                    <SaveCancelButton
                        saveItem={() => submitForm()}
                        cancelEdit={fetchData}
                        showText={false}
                    /></div>
            </CustomTd>
        </tr>
    );
}

export default PaymentEditor;

const paymentValidator = (payment) => {
    let isValid = true;

    if (payment.amount === '' || payment.amount < 0.001) {
        payment.amount_error = 'Required';
        isValid = false;
    } else {
        payment.amount_error = undefined;
    }

    if (payment.date === '') {
        payment.date_error = 'Required';
        isValid = false;
    } else {
        payment.date_error = undefined;
    }

    if (!payment.paymentType) {
        payment.paymentType_error = 'Required';
        isValid = false;
    } else {
        payment.paymentType_error = undefined;
    }

    if (!isValid) return false;

    return true;
}